import Joi from 'joi';

import { DayOfWeekEnum } from '../../../../shared/enums/day-of-week.enum';

const dateRangeSchema = () =>
	Joi.object({
		dateFrom: Joi.date().iso().allow(null).optional(),
		dateTo: Joi.date().iso().allow(null).optional(),
		name: Joi.string().allow(null).optional(),
	}).unknown(false);

/**
 * Schema for working periods policy config validation
 */
export const workingPeriodsConfigSchema = () =>
	Joi.object({
		operatingHours: Joi.array()
			.items(
				Joi.object({
					start: Joi.string().required(),
					end: Joi.string().required(),
				}).unknown(false),
			)
			.allow(null)
			.optional(),

		operatingWeekDays: Joi.array()
			.items(Joi.string().valid(...Object.values(DayOfWeekEnum)))
			.allow(null)
			.optional(),

		closed: Joi.array().items(dateRangeSchema()).allow(null).optional(),

		publicHolidays: Joi.array().items(dateRangeSchema()).allow(null).optional(),
	}).unknown(false);
